import { render, staticRenderFns } from "./TemplateTriggers.vue?vue&type=template&id=5493561c&scoped=true"
import script from "./TemplateTriggers.vue?vue&type=script&lang=js"
export * from "./TemplateTriggers.vue?vue&type=script&lang=js"
import style0 from "./TemplateTriggers.vue?vue&type=style&index=0&id=5493561c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5493561c",
  null
  
)

export default component.exports